export interface FeatureFlagsServiceConfig {
	getFeaturesUrl?: string;
}

/**
 * Optional on purpose: a missing URL dims one feature instead of 500ing the
 * storefront, which is what a required var would do.
 */
export function loadFeatureFlagsServiceConfig(): FeatureFlagsServiceConfig {
	const { FEATURE_FLAGS_URI } = process.env;

	return {
		getFeaturesUrl: FEATURE_FLAGS_URI || undefined
	};
}
